/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (!prevLocation || location.pathname === prevLocation.pathname) return
  if (location.hash) return

  window.requestAnimationFrame(() => {
    const mobileScroller = document.getElementById("gatsby-focus-wrapper")

    mobileScroller?.scrollTo({ top: 0, left: 0, behavior: "auto" })
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  })
}
